





























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  parseZhinengwuzangResult,
  getEvilBarOption,
  getOrganRadarOption,
  getYangYinBarOption,
  ZhinengwuzangParsed,
} from "@/utils/parseZhinengwuzang";

@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;

  private parsed: ZhinengwuzangParsed | null = null;
  private evilBarOption: any = {};
  private organRadarOption: any = {};
  private yangYinBarOption: any = {};

  private get mainSymptoms(): string {
    const parts: string[] = [];
    const main = (this.data["主要症状"] || "").trim();
    const tongue = (this.data["舌脉症状"] || "").trim();
    if (main) {
      parts.push(main);
    }
    if (tongue) {
      parts.push(tongue);
    }
    return parts.length > 0 ? parts.join("；") : "/";
  }

  private get constitutionType(): string {
    if (this.data["体质类型"]) {
      return this.data["体质类型"];
    }
    return this.parsed ? this.parsed.mainConstitution : "";
  }

  private get constitutionResult(): string {
    if (this.data["体质辨识结果"]) {
      return this.data["体质辨识结果"];
    }
    return this.parsed ? this.parsed.constitutionText : "";
  }

  private get syndromeResult(): string {
    return this.parsed ? this.parsed.syndromeText : "";
  }

  @Watch("data", { immediate: true, deep: true })
  private dataChange() {
    this.parseData();
  }

  private parseData() {
    const raw =
      this.data["评估结果"] || this.data["中医辨证结果"] || "";
    this.parsed = parseZhinengwuzangResult(raw);
    if (!this.parsed) {
      return;
    }
    if (this.parsed.chartCount >= 3) {
      this.evilBarOption = getEvilBarOption(this.parsed.evilScores);
      this.yangYinBarOption = getYangYinBarOption(
        this.parsed.yangScore,
        this.parsed.yinScore
      );
    }
    if (this.parsed.chartCount >= 1) {
      this.organRadarOption = getOrganRadarOption(this.parsed.organScores);
    }
  }

  private open(item: any) {
    this.$emit("open", item);
  }
}
